"use strict";

require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.for-each");
require("core-js/modules/es6.string.trim");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.date.to-string");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Body_1 = require("Core/Body");
var Languages_1 = require("Core/Languages");
var Notifications_1 = require("Core/Notifications");
var GuestModal_1 = require("Components/Cart/GuestModal");
var GuestModal_2 = require("Components/Cart/GuestModal");
var GuestModal_3 = require("Components/Cart/GuestModal");
exports.GuestModal = GuestModal_3.GuestModal;
var CartCalc_1 = require("Components/Cart/CartCalc");
var Step2Selectors_1 = require("Components/Cart/Step2/Step2Selectors");
var CommonFunctions_1 = require("Components/CommonFunctions");
require("bootstrap/js/src/modal");
var Events_1 = require("Core/Events");
require("../../../../js/inPost/inPost");
require("select2");
exports.Step2Component = function () {
  var COMMON = Step2Selectors_1.Step2Selectors.COMMON,
    DELIVERY_FORM_FIELDS = Step2Selectors_1.Step2Selectors.DELIVERY_FORM_FIELDS,
    ANOTHER_DELIVERY_FORM_FIELDS = Step2Selectors_1.Step2Selectors.ANOTHER_DELIVERY_FORM_FIELDS,
    FORM_FIELDS_ERROR = Step2Selectors_1.Step2Selectors.FORM_FIELDS_ERROR,
    DEPARTMENTS = Step2Selectors_1.Step2Selectors.DEPARTMENTS,
    PARCEL_LOCKER = Step2Selectors_1.Step2Selectors.PARCEL_LOCKER;
  var PARCEL_LOCKER_CODE = 3;
  var DeliveryInput = $(COMMON.DELIVERY).find('input');
  var PaymentInput = $(COMMON.PAYMENT).find('input');
  var CollectionInPersonDeliveryMethodID = 12;
  var t = {
    submitError: {
      "pl": 'Wystąpił błąd w wysyłaniu formularza',
      "en": 'An error occurred while sending the form',
      "ru": 'При отправке формы произошла ошибка'
    },
    paymentError: {
      "pl": 'Nie wybrano metody płatności!',
      "en": 'Payment method not selected!',
      "ru": 'Способ оплаты не выбран!'
    },
    passwordError: {
      "pl": 'Hasło jest nieprawidłowe',
      "en": 'The password is incorrect',
      "ru": 'Пароль неправильный'
    },
    deliveryError: {
      "pl": 'Nie wybrano metody dostawy',
      "en": 'Delivery method not selected!',
      "ru": 'Способ доставки не выбран!'
    },
    noParcelLockerError: {
      "pl": 'Nie wybrano paczkomatu',
      "en": 'ParcelLocker not selected',
      "ru": 'Способ доставки не выбран!'
    }
  };
  var language = Languages_1.getCurrentLanguage;
  var mapInstance = null;
  function showModal() {
    $(COMMON.MODAL).modal("show");
    $(COMMON.ALLOW_GUEST_CHECKER).val("true");
    $("select").select2();
  }
  function showDepartmentModal() {
    $(DEPARTMENTS.MODAL_SELECT).select2({
      dropdownParent: $("#DepartmentsModal")
    });
    if ($(COMMON.SELECTED_DELIVERY_RADIO).val() == 12) {
      $(DEPARTMENTS.MODAL).modal("show");
      $(DEPARTMENTS.ADDRESS_DIV).show();
      $(DEPARTMENTS.ID_INPUT).data('rule-required', true);
    } else {
      $(DEPARTMENTS.ADDRESS_DIV).hide();
      $(DEPARTMENTS.ID_INPUT).val('');
      $(DEPARTMENTS.ID_INPUT).data('rule-required', false);
      $(DEPARTMENTS.ADDRESS).html('Brak salonu');
    }
  }
  function changeMapVoivodeship() {
    var $voivodeshipName = $(this).data('map-voivodeship');
    changeDepartmentVoivodeship($voivodeshipName);
  }
  function clickMapVoivodeshipListElement() {
    var $idDepartment = $(this).data('id-department');
    var $voivodeshipName = $(this).closest('.element-voivodeship').data('voivodeship');
    changeDepartmentVoivodeship($voivodeshipName);
    $(DEPARTMENTS.MAP_VOIVODESHIP_LIST_ELEM).removeClass('active');
    $(this).addClass('active');
    $(DEPARTMENTS.MODAL_SELECT).val($idDepartment).trigger('change');
  }
  function changeDepartmentSelect() {
    var $idDepartment = $(this).val();
    var $voivodeshipName = $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-id-department='" + $idDepartment + "']").closest('.element-voivodeship').data('voivodeship');
    changeDepartmentVoivodeship($voivodeshipName);
    $(DEPARTMENTS.MAP_VOIVODESHIP_LIST_ELEM).removeClass('active');
    $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find('div[data-id-department="' + $idDepartment + '"]').addClass('active');
    $(DEPARTMENTS.MODAL_SELECT).val($idDepartment).trigger('change');
  }
  function changeDepartmentVoivodeship($voivodeshipName) {
    $(DEPARTMENTS.MAP_VOIVODESHIP).removeClass('active');
    $(DEPARTMENTS.MAP_VOIVODESHIP).find('path').removeClass('active');
    $(DEPARTMENTS.MAP_VOIVODESHIP + '[data-map-voivodeship=' + $voivodeshipName + ']').addClass('active');
    $(DEPARTMENTS.MAP_VOIVODESHIP + '[data-map-voivodeship=' + $voivodeshipName + ']').find('path').addClass('active');
    $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship!='" + $voivodeshipName + "']").hide();
    $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship='" + $voivodeshipName + "']").show();
    $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship!='" + $voivodeshipName + "'] div").hide();
    $(DEPARTMENTS.MAP_VOIVODESHIP_LIST).find("div[data-voivodeship='" + $voivodeshipName + "'] div").show();
    $('#department-map-list').find('#info-before-select').hide();
  }
  function submitModalForm(event) {
    event.preventDefault();
    var urlLang = Languages_1.getCurrentLanguageUrl;
    var $redirectUrl = $(COMMON.MODAL_FORM).find('#login_redirect_url').val();
    $.post(urlLang + "/login/?check=1", $(COMMON.MODAL_FORM).serialize(), function (res) {
      var json = JSON.parse(res);
      if (json.status === "success") {
        window.location.replace($redirectUrl.toString());
      } else {
        Notifications_1.Notifications.add(t.passwordError[language], 'error');
      }
    });
    return false;
  }
  function submitDepartmentForm(event) {
    event.preventDefault();
    var $idDepartment = $(DEPARTMENTS.MODAL_SELECT).find('option:selected').val();
    var $addressDepartment = $(DEPARTMENTS.MODAL_SELECT).find('option:selected').text();
    CommonFunctions_1.hideModal($(DEPARTMENTS.MODAL));
    if ($idDepartment) {
      $(DEPARTMENTS.ADDRESS_DIV).show();
      $(FORM_FIELDS_ERROR.ID_INPUT).css({
        "display": "none"
      });
      $(DEPARTMENTS.ADDRESS).html($addressDepartment);
      $(DEPARTMENTS.ID_INPUT).val($idDepartment);
    } else {
      $(FORM_FIELDS_ERROR.ID_INPUT).css({
        "display": "block"
      });
      $(DEPARTMENTS.ADDRESS).html('Brak salonu');
      $(DEPARTMENTS.ID_INPUT).val('');
    }
  }
  function checkIfGuestExistsAndShowModalIfYes(e) {
    e.preventDefault();
    var checkPayment = checkPaymentVisibility();
    $(COMMON.DELIVERY).removeClass('invalidComponent');
    $(COMMON.PAYMENT).removeClass('invalidComponent');
    if (!($(COMMON.SELECTED_DELIVERY_RADIO).length > 0)) {
      errorSetter(COMMON.DELIVERY, t.deliveryError[language]);
      return false;
    }
    if ($(COMMON.SELECTED_DELIVERY_RADIO).val() == PARCEL_LOCKER_CODE && $(PARCEL_LOCKER.SELECTED_LOCKER).attr('data-selected') == '0') {
      errorSetter(COMMON.DELIVERY, t.noParcelLockerError[language]);
      return false;
    }
    if (!($(COMMON.SELECTED_PAYMENT_RADIO).length > 0)) {
      errorSetter(COMMON.PAYMENT, t.paymentError[language]);
      return;
    }
    if ($(COMMON.SELECTED_PAYMENT_RADIO).length > 0 && checkPayment == false) {
      errorSetter(COMMON.PAYMENT, t.paymentError[language]);
      return;
    }
    if ($(COMMON.FORM).valid()) {
      var email_1 = $(COMMON.DELIVERY_EMAIL_INPUT).val();
      var FormSerialized_1 = $(COMMON.FORM).serialize();
      var urlLang = Languages_1.getCurrentLanguageUrl;
      if (email_1.trim()) {
        $.get(urlLang + "/cart/checkIfGuestAlreadyExists/" + email_1, function (data) {
          if (data === 'EXIST' && $(COMMON.ALLOW_GUEST_CHECKER).val() != 'true') {
            GuestModal_2.setEmail(email_1, COMMON.MODAL_EMAIL);
            GuestModal_1.setFormSerialized(FormSerialized_1, COMMON.MODAL_FORM_SERIALIZED);
            showModal();
            $(COMMON.ALLOW_GUEST_CHECKER).val("true");
            $("select").select2();
          } else {
            submitForm();
          }
        });
      } else {
        submitForm();
      }
    } else {
      Notifications_1.Notifications.add(t.submitError[language], 'error');
    }
  }
  function errorSetter(errorTarget, errorInfo) {
    event.preventDefault();
    $(errorTarget).addClass('invalidComponent');
    Notifications_1.Notifications.add(errorInfo, 'error');
  }
  function checkPaymentVisibility() {
    if ($(COMMON.SELECTED_PAYMENT_RADIO).next().is(':hidden')) {
      return false;
    }
  }
  function submitForm() {
    if (!($(COMMON.SELECTED_PAYMENT_RADIO).length > 0)) {
      Notifications_1.Notifications.add(t.paymentError[language], 'error');
      return false;
    }
    if (!($(COMMON.SELECTED_DELIVERY_RADIO).length > 0)) {
      Notifications_1.Notifications.add(t.deliveryError[language], 'error');
      return false;
    }
    if ($(COMMON.FORM).valid()) {
      $(COMMON.LAST_STEP_BTN).prop('disabled', true);
      $(COMMON.LAST_STEP_BTN_FINAL).prop('disabled', true);
      $(COMMON.LIGHT_PRELOADER).removeClass('d-none');
      $(COMMON.FORM).submit();
    } else {
      Notifications_1.Notifications.add(t.submitError[language], 'error');
    }
  }
  function copyDeliveryDataToForm(clickedButton) {
    var formToApplyFields;
    var fields;
    $(clickedButton).attr('id') == $(COMMON.COPY_INVOICE_BTN).attr('id') ? formToApplyFields = 'invoice' : formToApplyFields = 'another_delivery';
    formToApplyFields == 'invoice' ? fields = ['street', 'hnumber', 'lnumber', 'postal', 'city', 'email', 'phone'] : fields = ['first_name', 'last_name', 'street', 'hnumber', 'lnumber', 'postal', 'city', 'phone', 'email'];
    fields.forEach(function (field) {
      return $("#" + formToApplyFields + "_" + field).val($("#delivery_" + field).val());
    });
  }
  function toggleInvoiceDataVisibility(e) {
    e.preventDefault();
    $(COMMON.INVOICE_DATA).toggle();
  }
  function toggleAnotherDeliveryAddressFormVisibility(e) {
    e.preventDefault();
    $(COMMON.ANOTHER_DELIVERY_ADDRESS_DATA).toggle();
    toggleDeliveryMethodBlock();
  }
  function toggleDeliveryMethodBlock() {
    if ($(COMMON.DELIVERY_TILE_SALON).hasClass('locked')) {
      $(COMMON.DELIVERY_TILE_SALON).removeClass('locked');
    } else {
      $(COMMON.DELIVERY_TILE_SALON).addClass('locked');
      $(COMMON.DELIVERY_RADIO_SALON).prop('checked', false);
      $(COMMON.DELIVERY_RADIO_KURIER).prop('checked', true);
      $(DEPARTMENTS.ADDRESS_DIV).css("display", "none");
    }
  }
  function changePaymentMethodToPrzelewy() {
    $(COMMON.PAYMENT_METHOD_PRZELEWY).prop('checked', true);
  }
  function copingAnotherDeliveryData() {
    var $a = $(ANOTHER_DELIVERY_FORM_FIELDS.CART_SAVED_DELIVERY + " option:selected");
    $(ANOTHER_DELIVERY_FORM_FIELDS.DELIVERY_FIRST_NAME).val($a.data('first_name'));
    $(ANOTHER_DELIVERY_FORM_FIELDS.DELIVERY_LAST_NAME).val($a.data('last_name'));
    $(ANOTHER_DELIVERY_FORM_FIELDS.DELIVERY_STREET).val($a.data('street'));
    $(ANOTHER_DELIVERY_FORM_FIELDS.DELIVERY_HNUMBER).val($a.data('hnumber'));
    $(ANOTHER_DELIVERY_FORM_FIELDS.DELIVERY_LNUMBER).val($a.data('lnumber'));
    $(ANOTHER_DELIVERY_FORM_FIELDS.DELIVERY_POSTAL).val($a.data('postal'));
    $(ANOTHER_DELIVERY_FORM_FIELDS.DELIVERY_CITY).val($a.data('city'));
    $(ANOTHER_DELIVERY_FORM_FIELDS.DELIVERY_PHONE).val($a.data('phone'));
    $(ANOTHER_DELIVERY_FORM_FIELDS.DELIVERY_EMAIL).val($a.data('email'));
  }
  function initParcelLockerMap() {
    easyPack.init({
      instance: 'pl',
      mapType: 'osm',
      searchType: 'osm',
      points: {
        types: ['parcel_locker_only']
      },
      map: {
        useGeolocation: true,
        initialTypes: ['parcel_locker_only']
      }
    });
  }
  function openModal() {
    if (mapInstance == null) {
      mapInstance = easyPack.dropdownWidget(PARCEL_LOCKER.MAP_ELEMENT, function (point) {
        if (checkIsParcelLockerIsAvailable(point)) {
          var $input = $(PARCEL_LOCKER.SELECTED_LOCKER);
          var $lockerText = $(PARCEL_LOCKER.SELECTED_LOCKER_TEXT);
          $input.val(JSON.stringify(point));
          $input.attr('data-selected', '1');
          $lockerText.text(point.name);
          $(PARCEL_LOCKER.MODAL).modal('hide');
          $(PARCEL_LOCKER.MODAL_BACK).remove();
        } else {
          $(PARCEL_LOCKER.ERROR_MSG).show();
          setTimeout(function () {
            $(PARCEL_LOCKER.ERROR_MSG).hide();
          }, 5000);
        }
      });
    }
  }
  function checkIsParcelLockerIsAvailable(point) {
    return !(point.location.latitude == 0 && point.location.longitude == 0);
  }
  Body_1.$body.on('ready', PaymentInput, function () {
    return CartCalc_1.CartCalc.calcDelivery();
  });
  Body_1.$body.on('ready', DeliveryInput, function () {
    return CartCalc_1.CartCalc.calcDelivery();
  });
  Body_1.$body.on('submit', COMMON.FORM, function () {
    return CartCalc_1.CartCalc.checkPaymentAndDelivery;
  });
  $(window).on('load', PaymentInput, function () {
    return CartCalc_1.CartCalc.calcDelivery();
  });
  $(window).on('load', DeliveryInput, function () {
    return CartCalc_1.CartCalc.calcDelivery();
  });
  Events_1.onLoad(CartCalc_1.CartCalc.addPaymentDeliveryCost());
  $(DeliveryInput).on('click', DeliveryInput, CartCalc_1.CartCalc.addPaymentDeliveryCost);
  Body_1.$body.on('click', DeliveryInput, function () {
    return CartCalc_1.CartCalc.calcDelivery();
  });
  Body_1.$body.on('change', ANOTHER_DELIVERY_FORM_FIELDS.CART_SAVED_DELIVERY, copingAnotherDeliveryData);
  Body_1.$body.on('change', COMMON.FORM, function () {
    return CartCalc_1.CartCalc.calcDelivery();
  });
  Body_1.$body.on('change', COMMON.SELECTED_DELIVERY_RADIO, showDepartmentModal);
  Body_1.$body.on('click', COMMON.LOGIN_WHEN_USER_IS_GUEST_BTN, submitModalForm);
  Body_1.$body.on('click', DEPARTMENTS.CHANGE_BTN, showDepartmentModal);
  Body_1.$body.on('click', DEPARTMENTS.SUBMIT_BTN, submitDepartmentForm);
  Body_1.$body.on('click', DEPARTMENTS.MAP_VOIVODESHIP, changeMapVoivodeship);
  Body_1.$body.on('click', DEPARTMENTS.MAP_VOIVODESHIP_LIST_ELEM, clickMapVoivodeshipListElement);
  Body_1.$body.on('click', COMMON.LAST_STEP_BTN, checkIfGuestExistsAndShowModalIfYes);
  Body_1.$body.on('click', COMMON.LAST_STEP_BTN_FINAL, submitForm);
  Body_1.$body.on('click', COMMON.DELIVERY_TILE_SALON, changePaymentMethodToPrzelewy);
  Body_1.$body.on('click', COMMON.CONTINUE_AS_GUEST_BTN, submitForm);
  Body_1.$body.on('change', COMMON.WANT_ANOTHER_DELIVERY_ADRESS_CHECKBOX, toggleAnotherDeliveryAddressFormVisibility);
  Body_1.$body.on('change', "" + COMMON.WANT_INVOICE_CHECKBOX, toggleInvoiceDataVisibility);
  Body_1.$body.on('click', COMMON.COPY_INVOICE_BTN + ", " + COMMON.COPY_ANOTHER_DELIVERY_ADRESSES_BTN, function () {
    copyDeliveryDataToForm(this);
  });
  Body_1.$body.on('select2:select', DEPARTMENTS.MODAL_SELECT, changeDepartmentSelect);
  Events_1.onLoad(initParcelLockerMap);
  Events_1.onClick(PARCEL_LOCKER.SELECT_BUTTON, openModal);
}();